module.exports = __webpack_public_path__ + "static/media/20171216_002.aae5a585.mp4";